<template>
  <div class="form">
    <div class="form__header">
      <h3>Добавить работу</h3>
    </div>

    <div class="form__body">
      <p class="form__field">
        <input 
          type="file" 
          id="files" 
          ref="files" 
          multiple 
          @change="onFileUploads"
        />
        <label for="files"></label>
      </p>

      <ul class="drawings__list">
        <li 
          class="drawings__item"
          v-for="item in files"
          :key="item.id"
        >
          <Input 
            v-model="item.name" 
            label="Название" 
            type="text" 
            id="draw-name" 
          />

          <img :src="item.src" alt="">
        </li>
      </ul>
      <img id="result">
    </div>

    <div class="form__footer">
      <SubmitButton @submit="sendForm" />
    </div>
  </div>
</template>

<script>
import { form_mix } from '../../../mixins/form_mix'
export default {
  mixins: [ form_mix ],
  inject: ['http'],
  data() {
    return {
      files: []
    }
  },
  methods: {
    onFileUploads() {
      this.files = []
      let arr = Array.from(this.$refs.files.files)      

      arr.forEach(item => {  
        let reader = new FileReader();      
        let src = ''

        reader.readAsDataURL(item);

        reader.addEventListener('load', () => {
          src = reader.result

          this.files.push({
            name: item.name,
            file: item,
            src
          })
        })              
      })
    },
    sendForm() {
      let data = new FormData()

      for(let i = 0; i < this.files.length; i++ ){
        data.append('files[' + i + ']', this.files[i].file);
        data.append('names[' + i + ']', this.files[i].name)
      }

      data.append('contest_id', 1)

      this.http.post('onSaveContestFiles', data).then(res => {
        this.$emit('close-popup')
        this.$emit('add-drawings', res.data)
        swal('Успешно!', 'Рисунки загружены', 'success')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.drawings__list {
  margin-top: 40px;
  padding: 0;
  list-style: none;
}

.drawings__item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 20px;
  box-shadow: 0 2px 5px 0 #666666;
  border-radius: 8px;
  margin-bottom: 20px;

  & img {
    width: 100px;
    margin-left: 20px;
  }
}
</style>
